module.exports = __webpack_public_path__ + "static/fipcwhiteelephant3-80f0665f313b546dd852a16c7acf1ad6.jpeg";